const modulesFiles = require.context('./modules', true, /\.js$/)

export const newRouter = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const realName = moduleName.split('/')[1]
  const value = modulesFiles(modulePath)
  modules[realName] = value.default
  return modules
}, {})